
import Icon from 'vux/src/components/icon/index.vue'

import CcDialog from "./dialog.vue";
import { Dialog } from 'vant';

export default {
props: {
items: {
type: Array,
required: true
},
columnId: {
type: String,
required: false
},
showNum: {

type: Number,
required: false,
default: 5
},
isFree: {
type: Boolean,
required: false,
default: false
},
isBuy: {
type: Boolean,
required: false,
default: false
},
accessRegion:{
type: Boolean,
required: false,
default: true
},
mode: {
type: String,
required: false,
default: "link"
},
actIndex: {
type: Number,
required: false,
default: 0
},
isLogin: {
type: Boolean,
required: false
}
},
watch: {
items: {
handler(newD, oldD) {





},
immediate: true,
deep: true
},
actIndex: {
handler() {

this.setActivity();
},
immediate: true,
deep: true
}
},
components: {
Icon,
CcDialog,
[Dialog.Component.name]: Dialog.Component
},
data() {
return {
BuyDialog: false,
iconAll: {
iconNone: require("@/assets/image/icon/dele.png"),
iconPlayBlack: require("@/assets/image/icon/icon_play_b.png"),
iconPlayBlack2: require("@/assets/image/icon/icon_play_b2.png"),
iconGroup: require("@/assets/image/icon/icon_h_group.png"),
iconLock: require("@/assets/image/icon/icon_lock.png")
},
listLen: 5,
index: -1,
play: false,
player: {
video: { path: "videoDetail" },
audio: { path: "audioDetail" }
},
};
},
methods: {

setActivity() {
if (this.items.length > 0) {
this.items.forEach((item, idx) => {
if (this.actIndex == idx) {
item.isPlaying = true;
} else {
item.isPlaying = false;
}
});
}

this.$set(this.items, this.actIndex, this.items[this.actIndex]);
},

doPlay(index) {
let itemObj = this.items[index];
console.log(itemObj, 'accessRegion', this.accessRegion);

if(!this.accessRegion){
Dialog({ message: this.$t('PAGE_HEADER_TITLE.regionTitleAudio') });
return;
}

if (!this.isFree && itemObj.isBuy != 1 && itemObj.canTry != 1) {
if(this.SERVER.APPID == "orangenews"){
if(this.isLogin){
this.$routerHelper.goBuyPage(this.$router,this.columnId,"medialist")
}else{
this.$router.push({
path: '/login'
})
}
}else{

if(this.isLogin){

this.$dialog.confirm({
message: this.$t('AUDIOPLAYERDE_LANG.shwoDialog.1'),
confirmButtonText: this.$t('AUDIOPLAYERDE_LANG.shwoDialog.2')
}).then(() => {
this.$routerHelper.goBuyPage(this.$router,this.columnId,"medialist")
}).catch(() => { });
}else{

this.$dialog.confirm({
message: this.$t('AUDIOPLAYERDE_LANG.showDialogLoginEnd.1'),
confirmButtonText: this.$t('AUDIOPLAYERDE_LANG.showDialogLoginEnd.2')
}).then(() => {
this.$router.push({
path: '/login'
})
}).catch(() => { });
}
}
return;
}

if (this.items.length > 0) {
this.items.forEach((item, idx) => {
if (index == idx) {
item.isPlaying = true;
} else {
item.isPlaying = false;
}
});
}


this.$set(this.items, index, this.items[index]);


if (this.mode === "link") {
let mediaType = itemObj.mediaType;
this.$router.push({
path: this.player[mediaType].path,
query:{
columnId: this.columnId,
id: itemObj.id,
mode: "local"
}
})

}else{
this.$emit('onItemClick', this.items[index], index)
}
},
showMore() {
this.listLen += 10;
},
hideMore() {
this.listLen = 5;
}
},
mounted() {

}
};



// WEBPACK FOOTER //
// ./src/components/catalog.vue